import React, { createContext, useContext } from "react";

export type ReadOnlyContextType = {
  readOnly: boolean;
  setReadOnly: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ReadOnlyContext = createContext<ReadOnlyContextType>({
  readOnly: false,
  setReadOnly: () => {},
});

export const useReadOnly = (): ReadOnlyContextType => {
  const { readOnly, setReadOnly } = useContext(ReadOnlyContext);
  return { readOnly, setReadOnly };
};
